"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class TimelineController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            get: 'v1/case/:objectId/timeline',
            create: 'v1/case/:objectId/customEvent',
            edit: 'v1/customEvent/:objectId',
            delete: 'v1/customEvent/:objectId',
        };
    }
}
exports.default = TimelineController;
